import { areShadeCharacteristicsEqual } from "../shade";
import type { DeepPartial } from "../types";
import type {
  MaterialCharacteristics,
  MaterialCharacteristicsWithoutShade,
  MaterialCharacteristicsWithShade,
} from "./materialCharacteristics.types";

// TODO: Ideally this logic should be in the back

export const isPartialMaterialCharacteristicsWithShade = (
  materialCharacteristics: DeepPartial<MaterialCharacteristics>
): materialCharacteristics is DeepPartial<MaterialCharacteristicsWithShade> =>
  materialCharacteristics.material !== "METAL_NON_PRECIOUS";

export const isMaterialCharacteristicsWithShade = (
  materialCharacteristics: MaterialCharacteristics
): materialCharacteristics is MaterialCharacteristicsWithShade =>
  isPartialMaterialCharacteristicsWithShade(materialCharacteristics);

export const isPartialMaterialCharacteristicsWithoutShade = (
  materialCharacteristics: DeepPartial<MaterialCharacteristics>
): materialCharacteristics is DeepPartial<MaterialCharacteristicsWithoutShade> =>
  !materialCharacteristics.material ||
  materialCharacteristics.material === "METAL_NON_PRECIOUS";

export const isMaterialCharacteristicsWithoutShade = (
  materialCharacteristics: MaterialCharacteristics
): materialCharacteristics is MaterialCharacteristicsWithoutShade =>
  isPartialMaterialCharacteristicsWithoutShade(materialCharacteristics);

export const areMaterialCharacteristicsEqual = (
  materialCharacteristics1: DeepPartial<MaterialCharacteristics>,
  materialCharacteristics2: DeepPartial<MaterialCharacteristics>
) => {
  if (
    isPartialMaterialCharacteristicsWithoutShade(materialCharacteristics1) &&
    isPartialMaterialCharacteristicsWithoutShade(materialCharacteristics2)
  ) {
    return (
      materialCharacteristics1.material === materialCharacteristics2.material
    );
  }

  if (
    isPartialMaterialCharacteristicsWithShade(materialCharacteristics1) &&
    isPartialMaterialCharacteristicsWithShade(materialCharacteristics2)
  ) {
    return (
      materialCharacteristics1.material === materialCharacteristics2.material &&
      areShadeCharacteristicsEqual(
        materialCharacteristics1.shadeCharacteristics ?? {},
        materialCharacteristics2.shadeCharacteristics ?? {}
      )
    );
  }
  return false;
};
